const initDonationTerms = () => {
  const elements = document.querySelectorAll("#lendahand, #foundation");

  elements.forEach((element) => {
    if (element.dataset.mounted) return;
    element.dataset.mounted = "true";

    const checkbox = document.getElementById("terms_accepted");
    const popoverLendahand = document.getElementById("popover_lendahand");
    const popoverFoundation = document.getElementById("popover_foundation");

    const updateState = (radio) => {
      if (radio.checked) {
        if (checkbox) {
          checkbox.disabled = false;
        }

        if (radio.id === "lendahand") {
          if (popoverLendahand) popoverLendahand.classList.remove("d-none");
          if (popoverFoundation) popoverFoundation.classList.add("d-none");
        } else if (radio.id === "foundation") {
          if (popoverFoundation) popoverFoundation.classList.remove("d-none");
          if (popoverLendahand) popoverLendahand.classList.add("d-none");
        }
      }
    };

    element.addEventListener("change", function() {
      updateState(this);
    });

    // Check initial state
    updateState(element);
  });
};

document.addEventListener("DOMContentLoaded", initDonationTerms);
